module.exports = __webpack_public_path__ + "LGFabout-5.900987d3.png";